import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { Panel } from "primereact/panel";
import { memo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useReactToPrint } from "react-to-print";
import ChartDataLabels from "chartjs-plugin-datalabels";

function getCurrentFiscalMonthYear(date) {
    const day = date.getDate();
    let month = date.getMonth() + 1; 
    let year = date.getFullYear();
    if (day > 15) {
        month += 1;
        if (month > 12) {
            month = 1;
            year += 1;
        }
    }
    return { mes: month, ano: year };
}

export default memo(function GraficoPercentualDefeito({
    data,
    finalDate,
    meta
}) {
    const [printingAll, setPrintingAll] = useState(false);
    const componentRef = useRef();

    const handlePrintAll = useReactToPrint({
        content: () => componentRef.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrintingAll(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrintingAll(false);
        }
    });

    if (!data || !data.porcentagem_total || !finalDate) {
        return null;
    }

    const nomesMeses = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    const fiscalFinal = getCurrentFiscalMonthYear(finalDate);

    const meses = [];
    for (let i = 4; i >= 0; i--) {
        let mes = fiscalFinal.mes - i;
        let ano = fiscalFinal.ano;
        while (mes <= 0) {
            mes += 12;
            ano -= 1;
        }
        meses.push({ mes, ano });
    }

    const valores = meses.map((item) => {
        const encontrado = data.porcentagem_total.find(
            (element) => element.mes === item.mes && element.ano === item.ano
        );

        return encontrado ? parseFloat(encontrado.porcentagem_revisado) : 0;
    });

    const labels = meses.map((item) => {
        return `${nomesMeses[item.mes - 1]}/${item.ano}`;
    });

    const valoresMeta = Array(meses.length).fill(parseFloat(meta) || 0);

    const chartData = {
        labels: labels,
        datasets: [
            {
                type: "line",
                label: "Meta",
                data: valoresMeta,
                borderColor: "#e74c3c",
                borderWidth: 2,
                fill: false,
                tension: 0,
                pointRadius: 3,
                pointBackgroundColor: "#e74c3c",
                datalabels: {
                    display: false
                }
            },
            {
                type: "bar",
                label: "Percentual de defeitos",
                data: valores,
                backgroundColor: "#3498db",
            }
        ]
    };

    return (
        <Panel header="GRÁFICO DE PERCENTUAL DE DEFEITOS - ÚLTIMOS 5 MESES" toggleable collapsed={true}>
            <Card className="p-elevation-8">
                {!printingAll && (
                    <Button
                        className="p-m-2"
                        icon="pi pi-print"
                        onClick={handlePrintAll}
                    />
                )}

                <div ref={componentRef}>
                    <Chart
                        id="graficoPercentualDefeitos"
                        data={chartData}
                        height={printingAll ? "210mm" : "450px"}
                        width={printingAll ? "297mm" : "100%"}
                        options={{
                            maintainAspectRatio: false,
                            layout: { padding: 20 },
                            plugins: {
                                datalabels: {
                                    anchor: "end",
                                    align: "end",
                                    formatter: (value) => {
                                        if (value === 0) return "";
                                        return (
                                            Intl.NumberFormat("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            }).format(value) + "%"
                                        );
                                    },
                                    font: { size: 24 },
                                    color: "#2c3e50",
                                },
                                title: {
                                    display: true,
                                    text: "PERCENTUAL DE DEFEITOS - ÚLTIMOS 5 MESES",
                                    font: { size: 20 },
                                },
                            },
                            scales: {
                                x: {
                                    ticks: {
                                        font: { size: 16 },
                                        color: "#000",
                                    },
                                },
                                y: {
                                    beginAtZero: true,
                                    ticks: {
                                        callback: (value) => {
                                            return (
                                                Intl.NumberFormat("pt-BR", {
                                                    maximumFractionDigits: 2,
                                                }).format(value) + "%"
                                            );
                                        },
                                        font: { size: 14 },
                                        color: "#000",
                                    },
                                },
                            },
                        }}
                        plugins={[ChartDataLabels]}
                        type="bar"
                    />
                </div>
            </Card>
        </Panel>
    );
});